import { Component } from "@angular/core";

@Component({
  selector: "login",
  template: require('./login.component.html'),
})

export class LoginComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-router-loader/src!./~/angular2-template-loader!./src/app/auth/login.component.ts
 **/